import { RichAssetDatePicker, RichAssetTimePicker, RichAssetFileUpload, RichAssetWebView, } from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME, VALID_BEHAVIORS, } from '../../common/constants.js';
import { RichAssetTypesDisplayNames } from '../../common/mappings.js';
export function validateBehaviors(node, nodeFields, accept) {
    const { behaviorsField, idField, nodeTypeField, richAssetField } = nodeFields;
    const behaviors = behaviorsField?.behaviors?.map((b) => b.value) || [];
    const behaviorFlags = {};
    // We want to ensure that if any behaviors are provided, they
    // are from the list of valid behaviors
    const validBehaviors = Object.values(VALID_BEHAVIORS);
    behaviors.forEach((behavior) => {
        if (validBehaviors.indexOf(behavior) === -1) {
            accept('error', `Invalid behavior value '${behavior}' found.`, {
                node: behaviorsField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.BEHAVIORS,
                },
            });
        }
        else {
            // Also check that a behavior is not listed more than once
            if (behaviorFlags[behavior]) {
                accept('error', `Duplicate value '${behavior}' found in behaviors field.`, {
                    node: behaviorsField || node,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.BEHAVIORS,
                    },
                });
            }
            behaviorFlags[behavior] = true;
        }
    });
    // For specific rich assets, the behavior must include disable_input
    if (nodeTypeField?.nodeType?.value === 'D' &&
        richAssetField &&
        [
            RichAssetDatePicker.$type,
            RichAssetTimePicker.$type,
            RichAssetFileUpload.$type,
        ].indexOf(richAssetField?.content?.$type) !== -1) {
        // behaviors must include disable_input
        if (behaviors.indexOf(VALID_BEHAVIORS.DISABLE_INPUT) === -1) {
            accept('error', `Behaviors must include '${VALID_BEHAVIORS.DISABLE_INPUT}' when ${RichAssetTypesDisplayNames[richAssetField.content.$type]} is specified.`, {
                node: behaviorsField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.BEHAVIORS,
                },
            });
        }
    }
    // If the behaviors include inline, then the rich asset should be webview
    const hasInlineBehavior = behaviors.indexOf(VALID_BEHAVIORS.INLINE) !== -1;
    if (hasInlineBehavior &&
        richAssetField?.content?.$type !== RichAssetWebView.$type) {
        accept('error', `Inline behavior is only available for webview.`, {
            node: behaviorsField || node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.BEHAVIORS,
            },
        });
    }
    // For action nodes, the only behavior that can be
    // specified is out_of_scope
    if (nodeTypeField?.nodeType?.value === 'A') {
        behaviors.forEach((behavior) => {
            if (behavior !== VALID_BEHAVIORS.OUT_OF_SCOPE) {
                accept('error', `'${behavior}' can not be defined for an action node.`, {
                    node: behaviorsField || node,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.BEHAVIORS,
                    },
                });
            }
        });
    }
}
//# sourceMappingURL=validate-behaviors.js.map